<template>
    <DataSortFilter
        v-bind="$attrs"
        size="default"
        class="sort-media-library"
        :model-value="modelValue"
        :label="label"
        :options="options"
    />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import DataSortFilter from "@/components/DataSortFilter.vue";
import { defaultMediaLibrarySortBy } from "@/store/modules/mediaLibrary";

export default defineComponent({
    name: "SortMediaLibrary",
    components: { DataSortFilter },
    inheritAttrs: false,
    props: {
        modelValue: {
            type: String,
            default: defaultMediaLibrarySortBy
        }
    },
    data() {
        return {
            options: [
                {
                    field: "Name",
                    ascValue: "name_ASC",
                    ascOptionDirection: "A to Z",
                    descValue: "name_DESC",
                    descOptionDirection: "Z to A"
                },

                {
                    field: "Updated",
                    descValue: "modified_ASC",
                    descOptionDirection: "Old to New",
                    ascValue: "modified_DESC",
                    ascOptionDirection: "New to Old"
                },

                {
                    field: "Created",
                    descValue: "created_ASC",
                    descOptionDirection: "Old to New",
                    ascValue: "created_DESC",
                    ascOptionDirection: "New to Old"
                },

                {
                    field: "Type",
                    ascValue: "type_ASC",
                    ascOptionDirection: "File first",
                    descValue: "type_DESC",
                    descOptionDirection: "Folder first"
                }
            ],
            label: "Sort by:"
        };
    }
});
</script>

<style lang="scss">
.sort-media-library {
    &.data-sort .ivu-form-item-label {
        height: 34px;
    }
}
</style>
